(function () {
  'use strict';

  /* ── ACORDEÓN DE CATEGORÍAS ── */
  function initCategoryAccordion() {
    const toggles = document.querySelectorAll('[data-cat-toggle]');
    if (!toggles.length) return;

    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const group   = btn.closest('.ro-cat-group');
        const subList = group ? group.querySelector('.ro-sub-list') : null;
        const isOpen  = btn.classList.contains('open');

        /* Cierra todos */
        toggles.forEach(function (b) {
          b.classList.remove('open');
          b.setAttribute('aria-expanded', 'false');
        });
        document.querySelectorAll('.ro-sub-list').forEach(function (sl) {
          sl.classList.remove('visible');
        });

        /* Abre el clicado (si estaba cerrado) */
        if (!isOpen && subList) {
          btn.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
          subList.classList.add('visible');
        }
      });
    });
  }

  /* ── FILTROS POR CHECKBOX → URL ── */
  function initCheckboxFilters() {
    const checkboxes = document.querySelectorAll('[data-filter-checkbox]');
    if (!checkboxes.length) return;

    checkboxes.forEach(function (chk) {
      chk.addEventListener('change', function () {
        applyFilters();
      });
    });
  }

  /* ── FILTRO DE PRECIO ── */
  function initPriceFilter() {
    const applyBtn = document.querySelector('[data-price-apply]');
    if (!applyBtn) return;

    applyBtn.addEventListener('click', function () {
      applyFilters();
    });

    document.querySelectorAll('[data-filter-price]').forEach(function (inp) {
      inp.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') applyFilters();
      });
    });
  }

  /* ── CONSTRUYE URL CON FILTROS ACTIVOS ── */
  function applyFilters() {
    const url    = new URL(window.location.href);
    const params = new URLSearchParams();

    const sort = url.searchParams.get('sort_by');
    if (sort) params.set('sort_by', sort);

    /* Checkboxes activos */
    document.querySelectorAll('[data-filter-checkbox]').forEach(function (chk) {
      if (chk.checked) {
        params.append(chk.name, chk.value);
      }
    });

    /* Precio (Shopify espera centavos) */
    const priceMin = document.getElementById('price-min');
    const priceMax = document.getElementById('price-max');

    if (priceMin && priceMin.value !== '') {
      params.set(priceMin.name, Math.round(parseFloat(priceMin.value) * 100));
    }
    if (priceMax && priceMax.value !== '') {
      params.set(priceMax.name, Math.round(parseFloat(priceMax.value) * 100));
    }

    window.location.href = url.pathname + '?' + params.toString();
  }

  /* ── INIT ── */
  document.addEventListener('DOMContentLoaded', function () {
    initCategoryAccordion();
    initCheckboxFilters();
    initPriceFilter();
  });

})();

/* ── BADGE DE DESCUENTO SOBRE LA IMAGEN ── */
function initDiscountBadges() {
  var cards = document.querySelectorAll('.card-wrapper.product-card-wrapper');
  cards.forEach(function(card) {
    var priceCompare = card.querySelector('s.price-item--regular');
    var priceSale = card.querySelector('.price-item--sale.price-item--last');

    if (priceCompare && priceSale) {
      var parsePrice = function(el) {
        return parseFloat(el.textContent.replace(/[^0-9.]/g, ''));
      };
      var original = parsePrice(priceCompare);
      var sale = parsePrice(priceSale);
      if (original > sale && sale > 0) {
        var pct = Math.round((1 - sale / original) * 100);
        if (pct > 0) {
          var badge = document.createElement('div');
          badge.className = 'ro-discount-overlay';
          badge.textContent = '-' + pct + '%';
          var imgArea = card.querySelector('.card__inner');
          if (imgArea) {
            imgArea.style.position = 'relative';
            imgArea.appendChild(badge);
          }
        }
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  initDiscountBadges();
});
/* ── MOVER VENDOR ARRIBA DEL TÍTULO ── */
function moveVendorAboveTitle() {
  var cards = document.querySelectorAll('.card-wrapper.product-card-wrapper');
  cards.forEach(function(card) {
    var vendor = card.querySelector('.card-information .caption-with-letter-spacing');
    var heading = card.querySelector('.card__heading.h5');
    if (vendor && heading && heading.parentElement) {
      heading.parentElement.insertBefore(vendor, heading);
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  moveVendorAboveTitle();
  initCategoryAccordion();
  initCheckboxFilters();
  initPriceFilter();
  initDiscountBadges();
});
/* ── COOKIE BANNER — recordar aceptación ── */
(function() {
  var banner = document.querySelector('.cookie-banner, [class*="cookie"], [id*="cookie"]');
  if (!banner) return;
  
  if (localStorage.getItem('ro_cookie_accepted')) {
    banner.style.display = 'none';
    return;
  }

  var btns = banner.querySelectorAll('button, a');
  btns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      localStorage.setItem('ro_cookie_accepted', '1');
    });
  });
})();